import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { YesNo } from "@app/utils/utils.component"

@Component({
	selector: "app-google2fa-qr-code",
	imports: [COMMON_IMPORTS, LangValPipe, GenButtonGroupComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div
			class="row"
			style="min-height:120px;font-size: 12px"
		>
			<div class="col-12">
				<p>{{ "2FA0" | langVal }}</p>
				<p>{{ "2FA1" | langVal }}</p>
				<p>{{ "2FA2" | langVal }}</p>
				<p>{{ "2FA3" | langVal }}</p>
				<p>{{ "2FA4" | langVal }}</p>
				<p>{{ "2FA5" | langVal }}</p>
				<p>{{ "2FA6" | langVal }}</p>
				<p>{{ "2FA7" | langVal }}</p>
			</div>
		</div>
		<div>
			<label>{{ "is_google2fa" | langVal }}</label>
			<app-gen-button-group
				[actualObj]="this"
				fieldName="is_google2fa"
				optionsListName="yes_no_opts"
				title_ph_lang="is_google2fa"
				(changeEvent)="save()"
			/>
		</div>
		<div
			class="row"
			style="min-height:120px;font-size: 16px"
		>
			<div
				class="col-12"
				style="padding: 30px"
			>
				@if (url) {
					<img [src]="url" />
				}
			</div>
		</div>
	`,
})
export class Google2faQrCodeComponent extends Modalable {
	url: string = "" //sdfdsf
	is_google2fa: string = "no"

	async ngOnInit() {
		this.is_google2fa = this.store.cc().is_google2fa
		const secret = await this.apiService.post("get_user_google2fa_secret")
		this.url = secret
		// this.url="https://chart.googleapis.com/chart?cht=qr&chs=300x300&chl="+secret;
	}

	async save() {
		//save to DB using the api
		//const result: any = await this.apiService.post("update_configcliniq_data", {
		const result: any = await this.apiService.post(
			"update_sub_user_configcliniq_data",
			{
				is_google2fa: this.is_google2fa,
			}
		)
		if (result && !result?.error) {
			//success
			const cliniqData = this.store.cc()
			cliniqData.is_google2fa = this.is_google2fa
			this.modalService.openToast("updated_successfully") //open toast with success message
			sessionStorage.setItem("cliniqData", JSON.stringify(cliniqData)) //update the config object in the sessionStorage
		} else {
			//fail
			this.modalService.openToast(result?.error) //open toast with fail message
		}
	}
}
